@if (ready) {
    @for (conf of listConfigs; track conf) {
        @if (isListConfig(conf)) {
            <generic-list-manager [config]="conf"></generic-list-manager>
        } @else {
            <div class="space-evenly">
                @if (conf.grossMatrixModel) {
                    <div class="detail-page-card">
                        <div class="detail-page-card-title">{{ 'data.grossRiskMatrixTitle' | t }}</div>
                        <div class="detail-page-card-body padded flex-center">
                            <cerrix-riskmatrix
                                [matrix]="conf.grossMatrixModel"
                                [highlightSelection]="false"
                                [cellSize]="50"
                            ></cerrix-riskmatrix>
                        </div>
                    </div>
                }
                @if (conf.netMatrixModel) {
                    <div class="detail-page-card">
                        <div class="detail-page-card-title">{{ 'data.netRiskMatrixTitle' | t }}</div>
                        <div class="detail-page-card-body padded flex-center">
                            <cerrix-riskmatrix
                                [matrix]="conf.netMatrixModel"
                                [highlightSelection]="false"
                                [cellSize]="50"
                            ></cerrix-riskmatrix>
                        </div>
                    </div>
                }
            </div>
        }
    }
}
